import Box from '@material-ui/core/Box'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { makeStyles } from '@material-ui/core/styles'
import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import { useAuthentication } from '../../../hooks/Authentication/useAuthentication'
import useValidation from '../../../hooks/Validation/useValidation'
import { ROUTES } from '../../../shared/constants'
import CustomButton from '../../CustomButton'
import AuthInputField from '../../AuthInputField'
import CustomLabel from '../../CustomLabel'
import PoweredByNural from '../../PoweredByNural'
import { Link } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'
import { UserContext } from '../../../context api/UserContext'
import { toastMessage } from '../../../shared/AlertPopup'

const useStyles = makeStyles((theme) => ({
  marginTop: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '40px',
    },
  },
  label: {
    color: 'black',
    fontSize: '12px',
    lineHeight: '20px',
    marginLeft: '45px',
  },
  loginOption: {
    position: 'relative',
    bottom: '-39px',
    margin: '0px 10%',
  },
  link: {
    color: '#32499F',
    cursor: 'pointer',
    marginLeft: '3px',
    '&:hover': { textDecoration: 'underline' },
    fontSize: '12px',
  },
  link2: {
    color: '#32499F',
    cursor: 'pointer',
    // marginLeft: '3px',
    '&:hover': { textDecoration: 'underline' },
    fontSize: '14px',
    marginTop: '10px',
  },
  options: {
    marginTop: '20px',
    // textAlign: 'center',
    // margin: '0px 54px',
    display: 'flex',

    // justifyContent: 'center',
  },
}))

export default function CreateNewPasswordForm({ handleClose }) {
  const classes = useStyles()
  const history = useHistory()
  // 7053617608
  const [confPassword, setConfPassword] = useState('')
  const [password, setPassword] = useState('')
  const { error, handleFormValidation } = useValidation()
  const { loading, updatePassword, acceptPolicy } = useAuthentication()
  const user = useContext(UserContext)
  const employee = user && user.user

  const handlePasswordChange = async () => {
    if (confPassword !== password) {
      return toastMessage("Both password Don't Match", 'error')
    } else {
      await acceptPolicy({ employeeId: employee._id })
      await updatePassword({ email: employee.email, phoneNumber: employee.phoneNumber, password: password })
      handleClose()
    }
  }

  return (
    <form>
      <AuthInputField
        placeholder="New Password"
        onKeyDown={(val) => handleFormValidation({ target: { value: val, name: 'password' } }, [{ type: 'PASSWORD' }])}
        className={classes.marginTop}
        errorMessage={error && error.password}
        handleChange={setPassword}
        value={password}
        type="password"
      />
      <AuthInputField
        placeholder="Confirm Password"
        onKeyDown={() => handleFormValidation({ target: { value: confPassword } })}
        className={classes.marginTop}
        errorMessage={error && error.confPassword}
        handleChange={setConfPassword}
        value={confPassword}
        type="password"
      />
      <br />
      <br />

      {/* <Box display="flex" justifyContent="space-between">
        <FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />
        <Link className={`${classes.label} ${classes.link2}`} to={ROUTES.FORGOT_PASSWORD}>
          {' '}
          Forgot Password ?{' '}
        </Link>
      </Box> */}
      <Box display="flex">
        {/* <CustomButton
          disabled={loading}
          text={loading ? <CircularProgress size="25px" color="inherit" /> : 'Cancel'}
          className={classes.marginTop}
          handleSubmit={handlePasswordChange}
        /> */}
        <CustomButton
          disabled={loading}
          text={loading ? <CircularProgress size="25px" color="inherit" /> : 'Change Password'}
          className={classes.marginTop}
          handleSubmit={handlePasswordChange}
        />
      </Box>
      <br />

      {/* <Box display="flex" className={classes.options}>
        <CustomLabel label="Don't have an account ?" className={classes.label} />
        <div className={`${classes.label} ${classes.link}`} onClick={() => history.push(ROUTES.SIGNUP)}>
          Create an account
        </div>
      </Box> */}
      {/* <div className={classes.loginOption}>
        <PoweredByNural />
      </div> */}
    </form>
  )
}
